export class TreatmentGroupHDModel {
    tgcode = '' ;
tgname = '' ;
compcode = '' ;
userid = '' ;

}
